/**
 * 初始化Date扩展函数
 */
export const initDateFunc = () => {
    Date.prototype.format = function(fmt) {
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    };
    
    /**
     * 增加指定天数
     * @param {*} day 天
     */
    Date.prototype.add = function(day) {
      return new Date(this.getTime() + 24 * 3600 * 1000 * day);
    };
  
    Date.prototype.diff = function(date) {
      let now = this.setHours(0, 0, 0, 0);
      let compare = date.setHours(0, 0, 0, 0);
      return (now - compare) / (24 * 3600 * 1000);
    };
  
    Date.prototype.parseChinese = dateString => {
      dateString = dateString.replace(/[年月]/g, "-").replace(/日/, "");
      if (!/年/.test(dateString))
        dateString = new Date().getFullYear() + "-" + dateString;
      return new Date(dateString);
    };

    Date.prototype.parseDayOfTheWeek = function() {
      return ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'][this.getDay()];
    }
  };


// WEBPACK FOOTER //
// ./src/utils/date.js